module.exports = __webpack_public_path__ + "img/3.7da35ca2.png";